import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettSupplier } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxSettSupplierForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  let r_form = React.useRef(null);

  const [storeSettSupplier, setStoreSettSupplier] = useSessionStorage('StoreSettSupplier', StoreSettSupplier);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
    } else {
      storeSettSupplier.itSupplier = lastSaveRv.theValue;
      Promise.all([setStoreSettSupplier(storeSettSupplier)]).then((result) => {
        navBack();
      });
    }
  }
  const formDelete = async (rv) => {
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.type')} - ${trans('field.supplier')}`}
        xref={r_form}
        url="sett/supplier" 
        filterIdField='itSupplier'
        filterIdValue={storeSettSupplier.itSupplier} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="t_supplier.itSupplier" value={storeSettSupplier.itSupplier || ''} />
        <CxInput xref={useRef(null)} label={`${trans('field.type')} - ${trans('field.supplier')}`} dbfield="t_supplier.txTypeSupplier" required />
        
      </GxForm>

    </div>
  );

}

export default MxSettSupplierForm;
